import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function volumeCapsuleChartHelp() {
    return (
        <IconTooltip>
            <div>
                The Volume capsule compares today&apos;s actual market volume to
                historical market average, while also showing today&apos;s
                predicted remaining volume.
                <br />
                <br />
                The yellow blocks indicate historical auction volumes (open and
                close) whereas the teal block indicates the historical
                continuous volume. The white overlay block shows today&apos;s
                actual volume and the transparent white block shows today&apos;s
                predicted remaining volume.
                <br />
                <br />
                The Volume capsule can be configured by selecting a symbol from
                your portfolio or adding it into settings.
            </div>
        </IconTooltip>
    );
}
